import { render, staticRenderFns } from "./ed-config-working-days.component.vue?vue&type=template&id=6ff05646&scoped=true&"
import script from "./ed-config-working-days.component.ts?vue&type=script&lang=ts&"
export * from "./ed-config-working-days.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-config-working-days.component.scss?vue&type=style&index=0&id=6ff05646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff05646",
  null
  
)

export default component.exports